import React from "react";
import { Row, Col } from "antd";
import { CustomLabel, SectionCardDark } from "../../Common/style";
import { maskPhoneNumber, maskedEmail } from "../../Utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useIsTablet } from "../../Hooks";
import CONSTANTS from "../../Utils/constant";
import TEXT_CONSTANTS from "./constants";
import PAGE_CONSTANTS from "../../Pages/Tracker/AppointmentBookingPage/constant";
import "./appointmentCard.css"

const RescheduleButton = ({onClick}) => {
  return (
    <div className="reschedule-btn" onClick={onClick}>
    {TEXT_CONSTANTS?.RESCHEDULE}
    <FontAwesomeIcon icon={faAngleRight} style={{ marginLeft: "9px" }} />
  </div>
  )
}

const AppointmentCard = ({name, appNo, address, date, time, type, clinicName = "", mobile, email}) => {
  const isTablet = useIsTablet();
  return (
    <Col md={24}>
      <SectionCardDark>
        <Row gutter={[0, 18]}>
          <Col xs={24} md={12} className="member-block">
            <Row gutter={[10, 24]}>
              <Col xs={12} sm={14} md={24}>
                <CustomLabel font_size="18" font_weight="bold">
                  {name || CONSTANTS?.NA}
                </CustomLabel>
              </Col>
              <Col xs={12} sm={10} md={24}>
                <CustomLabel font_size="14" font_weight="normal">
                  {TEXT_CONSTANTS?.APPLICATION_NO}
                  <b>{appNo || CONSTANTS?.NA}</b>
                </CustomLabel>
              </Col>
            </Row>
          </Col>
          <Col md={12} className="reschedule-block">
            <Row gutter={[0, { xs: 18, md: 24, lg: 24 }]}>
              {!isTablet && (
                <Col md={24} className="justify-flex-end">
                  <div className="justify-flex-center h-25">
                    <Col xs={4}>
                      <span className="start_icon" style={{ fontSize: "16px" }}>
                        <i
                          className="fa fa-calendar-check-o"
                          aria-hidden="true"
                        ></i>
                      </span>
                    </Col>
                    <Col xs={20}>
                      <CustomLabel
                        className="ml-2"
                        font_size="14"
                        font_weight="bold"
                      >
                        {date || CONSTANTS?.NA}
                      </CustomLabel>
                    </Col>
                  </div>
                  <div className="justify-flex-center h-25 ml-4">
                    <Col xs={4}>
                      <span className="start_icon" style={{ fontSize: "18px" }}>
                        <i className="fa fa-clock-o" aria-hidden="true"></i>
                      </span>
                    </Col>
                    <Col xs={20}>
                      <CustomLabel
                        className="ml-2"
                        font_size="14"
                        font_weight="bold"
                      >
                        {time || CONSTANTS?.NA}
                      </CustomLabel>
                    </Col>
                  </div>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md={24} className="venue-text">
            <CustomLabel font_size="18" font_weight="bold">
              {TEXT_CONSTANTS?.VENUE}
            </CustomLabel>
          </Col>
          <Col xs={24}>
            <CustomLabel font_size="14" font_weight="bold">
              {type === PAGE_CONSTANTS?.HOME_VISIT_TYPE
                ? TEXT_CONSTANTS?.HOME_ADDRESS
                : clinicName}
            </CustomLabel>
          </Col>
          <Col xs={24} style={{ marginTop: "9px" }}>
            <Row>
              <div className="flex">
                <Col xs={2} style={{ maxWidth: "25px" }}>
                  <span
                    className="start_icon flex"
                    style={{ fontSize: "20px" }}
                  >
                    <i className="fa fa-map-marker" aria-hidden="true"></i>
                  </span>
                </Col>
                <Col xs={22}>
                  <CustomLabel font_size="14" font_weight="normal">
                    {address || CONSTANTS?.NA}
                  </CustomLabel>
                </Col>
              </div>
            </Row>
          </Col>
        </Row>
        {isTablet && (
          <Row className="time-date-row">
            <Col xs={12} md={8}>
              <Row>
                <div className="justify-flex-center h-25">
                  <Col xs={2}>
                    <span className="start_icon" style={{ fontSize: "16px" }}>
                      <i
                        className="fa fa-calendar-check-o"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </Col>
                  <Col xs={22}>
                    <CustomLabel
                      className="ml-3"
                      font_size="14"
                      font_weight="bold"
                    >
                      {date || CONSTANTS?.NA}
                    </CustomLabel>
                  </Col>
                </div>
              </Row>
            </Col>
            <Col xs={12} md={8}>
              <Row>
                <div className="justify-flex-center h-25">
                  <Col xs={2}>
                    <span className="start_icon" style={{ fontSize: "18px" }}>
                      <i className="fa fa-clock-o" aria-hidden="true"></i>
                    </span>
                  </Col>
                  <Col xs={22}>
                    <CustomLabel
                      className="ml-3"
                      font_size="14"
                      font_weight="bold"
                    >
                      {time || CONSTANTS?.NA}
                    </CustomLabel>
                  </Col>
                </div>
              </Row>
            </Col>
          </Row>
        )}
        <Row className="mobile-email-row">
          <Col xs={12} md={8}>
            <Row>
              <Col xs={24}>
                <CustomLabel font_size="14" font_weight="bold">
                  {TEXT_CONSTANTS?.MOBILE_NUMBER}
                </CustomLabel>
              </Col>
              {mobile && (
                <div className="justify-flex-center h-25">
                  <Col xs={2}>
                    <span className="start_icon" style={{ fontSize: "24px" }}>
                      <i className="fa fa-mobile" aria-hidden="true"></i>
                    </span>
                  </Col>
                  <Col xs={22}>
                    <CustomLabel
                      className="ml-2"
                      font_size="14"
                      font_weight="normal"
                    >
                      {maskPhoneNumber(mobile) || CONSTANTS?.NA}
                    </CustomLabel>
                  </Col>
                </div>
              )}
            </Row>
          </Col>
          <Col xs={12} md={8}>
            <Row>
              <Col xs={24}>
                <CustomLabel font_size="14" font_weight="bold">
                  {TEXT_CONSTANTS?.EMAIL_ID}
                </CustomLabel>
              </Col>
              <div className="justify-flex-center h-25">
                <Col xs={2}>
                  <span className="start_icon" style={{ fontSize: "16px" }}>
                    <i className="fa fa-envelope" aria-hidden="true"></i>
                  </span>
                </Col>
                <Col xs={22}>
                  <CustomLabel
                    className="ml-3"
                    font_size="14"
                    font_weight="normal"
                  >
                    {maskedEmail(email) || CONSTANTS?.NA}
                  </CustomLabel>
                </Col>
              </div>
            </Row>
          </Col>
          <Col xs={24} md={24}>
            <CustomLabel className="" font_size="14" font_weight="bold" style={{ marginTop: "24px"}}>
              {
                "If no slots are available, our team will coordinate with you directly."
              }
            </CustomLabel>
          </Col>
          <Col xs={24} md={24}>
            <CustomLabel className="" font_size="14" font_weight="bold" style={{ marginTop: "24px"}}>
            {"Note: Please do not visit any diagnostic center until you received a confirmation via text or call from the center."}
            </CustomLabel>
          </Col>
        </Row>
      </SectionCardDark>
    </Col>
  );
}

export default AppointmentCard